/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {
  Entity,
  GenericObject
} from '@ion/core/src/types/entities';
import {
  MemberSearchCriteria,
  SmartSearchCriteria
} from '@ion/core/src/types/services';
import {convertModularSearchDateRange} from '@ion/core/src/utils/DateUtil';
import {createModularSearchFilters} from './utils';

interface BuildMemberSearchCriteria {
  accountId: number;
  viewSubGroups: boolean;
  entity: Entity;
  filters?: GenericObject;
}

// Builds a member search criteria with the given details.
export const buildMemberSearchCriteria = ({
  accountId,
  viewSubGroups,
  entity,
  filters
}: BuildMemberSearchCriteria): MemberSearchCriteria => {
  return {
    searchCriteria : [{
      memberSearch : {
        type        : entity,
        hierLevel   : viewSubGroups ? 'ALL' : '',
        searchTerms : {
          account : '' + accountId,
          ...createModularSearchFilters(filters)
        }
      }
    }]
  };
};

interface BuildSmartSearchCriteria {
  accountId: number;
  viewSubGroups: boolean;
  entity: Entity;
  queryString?: string;
}

// Builds a smart search criteria with the given details.
export const buildSmartSearchCriteria = ({
  accountId,
  viewSubGroups,
  entity,
  queryString
}: BuildSmartSearchCriteria): SmartSearchCriteria => {
  return {
    searchCriteria : [{
      smartSearch : {
        hierLevel : viewSubGroups ? 'ALL' : '',
        type      : entity,
        queryString,
        accountId
      }
    }]
  };
};

export const getSearchableDate  = (date: string): string => (`(${convertModularSearchDateRange(date, 'YYYY-MM-DD[T]HH[\\]:mm[\\]:ss.[000Z]')})`);
